import {
  readFromLocalStorage,
  writeToLocalStorage,
} from '../local-storage/local-storage';
import type { LocalStorageKey } from '../local-storage/types';

const DEFAULT_LOCALE_STORAGE_KEY: LocalStorageKey = {
  key: 'locale',
};

export type LocaleCode = 'sv-SE';

export const DEFAULT_LOCALE: LocaleCode = 'sv-SE';

const VALID_LOCALES: readonly LocaleCode[] = ['sv-SE'];

function isLocaleCode(value: unknown): value is LocaleCode {
  return (
    typeof value === 'string' && (VALID_LOCALES as readonly string[]).includes(value)
  );
}

export function getDefaultLocaleCode(): LocaleCode {
  const storedLocale = readFromLocalStorage<unknown>({
    ...DEFAULT_LOCALE_STORAGE_KEY,
    defaultValue: null,
  });

  return isLocaleCode(storedLocale) ? storedLocale : DEFAULT_LOCALE;
}

export function writeDefaultLocaleCode(localeCode: LocaleCode) {
  writeToLocalStorage({
    ...DEFAULT_LOCALE_STORAGE_KEY,
    value: localeCode,
  });
}
